import { type Metric } from 'web-vitals';

const reportWebVitals = (onPerfEntry?: (metric: Metric) => void) => {
    if (onPerfEntry && onPerfEntry instanceof Function) {
        import('web-vitals').then((webVitals) => {
            webVitals.onCLS(onPerfEntry);
            webVitals.onTTFB(onPerfEntry);
            webVitals.onFCP(onPerfEntry);
            webVitals.onLCP(onPerfEntry);
            webVitals.onTTFB(onPerfEntry);
        });
    }
};

export default reportWebVitals;
